import Icon from '../components/Icon.vue'

Icon.register({"hourglass-half":{"width":384,"height":512,"paths":[{"d":"M360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64 373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0zM284.9 384H99.1C116.1 337.2 151.2 304 192 304 232.8 304 267.9 337.2 284.9 384zM284.9 128H99.1C92 108.5 88 86.7 88 64H296C296 86.8 292 108.6 284.9 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hourglass-half.js
// module id = null
// module chunks = 